module.exports = __webpack_public_path__ + "static/media/GKGIF.606b21c4.gif";